// Angular + external
import { Component, OnInit, Input } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxInstallConfiguration } from "../../shared/auth-services/system-config/model/config.models";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-comment-warning",
  template: '<div class="bfx-comment-warning"><span>{{warningText}}</span></div>',
  standalone: false,
})
export class BfxCommentWarning implements OnInit {
  public warningText: string;

  @Input()
  public installConfigVar: string = "comment_warning";

  constructor(protected configService: BfxConfigService) {}

  ngOnInit(): void {
    if (this.installConfigVar != null) {
      this.configService.getInstallConfig().then((config: BfxInstallConfiguration) => {
        this.warningText =
          config[this.installConfigVar] != null ? config[this.installConfigVar] : "";
      });
    }
  }
}
